<script>
    import { createEventDispatcher } from 'svelte'
    import {
        additional_people_info,
        bucketPeopleBySurname,
        displayPersonFromID, displayPromotion,
        people_search_list
    } from "../stores/misc.js";
    import {I_SHORTLIST_PEOPLE} from "../../../../../lib/datatypes.js";
    import {inArray} from "../../../../../lib/utils";
    import {people} from "../stores/people";
    import SearchBox from "./SearchBox.svelte";
    import BucketChooser from "./BucketChooser.svelte";
    import {I_PERSON} from "../../../../../lib/datatypes";
    import {fullNameFromRawPerson} from "../stores/misc";
    import TagFilter from "./TagFilter.svelte";
    import {people_tags} from "../stores/people_tags";

    const dispatch = createEventDispatcher();

    let type = null;

    export let shortlist_people_arr = [];
    $: shortlist_people_list = shortlist_people_arr.map(shortlist_person => {
        return {
            person: displayPersonFromID(shortlist_person[I_SHORTLIST_PEOPLE.ID_PERSON]),
            status: shortlist_person[I_SHORTLIST_PEOPLE.STATUS]
        };
    });
    $: shortlist_people_ids = shortlist_people_arr.map(shortlist_person => `${shortlist_person[I_SHORTLIST_PEOPLE.ID_PERSON]}`);

    let current_search_str = '';
    let person_buckets = {};
    let chosen_letter = '';

    let filter_active = false;
    let filter = [];

    const runFilters = (person_list, filter) => {
        let person_tag_ids_arr = person_list[I_PERSON.TAGS].split(',').map(id => id.trim());
        let result = true;
        filter.forEach(row => {
            switch(row.has) {
                // 'HAS'
                case true:
                    // 'ALL OF'
                    if(row.all_of) {
                        for(let i = 0, n = row.tag_ids.length; i < n; i++) {
                            // If any tag isn't found, then it can't be true that all of them are present
                            if(!inArray(person_tag_ids_arr, row.tag_ids[i])) {
                                result = result && false;
                                return;
                            }
                        }
                        result = result && true;
                        return;
                    }
                    // 'ANY OF'
                    else {
                        for(let i = 0, n = row.tag_ids.length; i < n; i++) {
                            // If any tag is found, then it's true that one of them is present
                            if(inArray(person_tag_ids_arr, row.tag_ids[i])) {
                                result = result && true;
                                return;
                            }
                        }
                        result = result && false;
                        return;
                    }
                    break;
                // DOES NOT HAVE
                case false:
                    // NB 'all of' and 'any of' mean the same thing in practice when talking about 'does not have'
                    for(let i = 0, n = row.tag_ids.length; i < n; i++) {
                        // If any tag is found, then it can't be true that any or all of them are not present
                        if(inArray(person_tag_ids_arr, row.tag_ids[i])) {
                            result = result && false;
                            return;
                        }
                    }
                    result = result && true;
                    break;
            }
        });
        return result;
    };

    $: searched_users = current_search_str === '' ?
        $people.list.filter(person_arr => runFilters(person_arr, filter)) :
        $people_search_list.filter(entry => {
            return entry[0].includes(current_search_str.toLowerCase());
        }).map(entry => {
            return $people.lookup[entry[1]];
        }).filter(person_arr => runFilters(person_arr, filter));

    const MIN_PEOPLE_IN_SEARCH_TO_COLLAPSE = 50;
    $: {
        if(searched_users.length < MIN_PEOPLE_IN_SEARCH_TO_COLLAPSE) {
            person_buckets = {
                'all': searched_users
            };
        }
        else {
            person_buckets = bucketPeopleBySurname(searched_users);
        }
        if(!inArray(Object.keys(person_buckets), chosen_letter)) chosen_letter = Object.keys(person_buckets)[0];
    }

    // $: {
    //     console.log('shortlist_people_list', shortlist_people_list);
    // }

    const SHORTLIST_STATE = {
        ADD: 0,
        REMOVE: 1,
        SEND: 2
    };
    let shortlist_state = SHORTLIST_STATE.SEND;

    const onFilterButtonToggle = () => filter_active = !filter_active;

    const addPersonClicked = id => {
        dispatch('addPersonToShortlist', {id: id});
    };
    const removePersonClicked = id => {
        dispatch('removePersonFromShortlist', {id: id});
    };
    const viewPersonClicked = id => {
        dispatch('viewPersonClicked', {id: id});
    };

</script>

<div class="block">
    <nav class="isolate flex divide-x divide-gray-200 rounded-lg shadow" aria-label="Tabs">
        <!-- Current: "text-gray-900", Default: "text-gray-500 hover:text-gray-700" -->
        <a on:click|preventDefault={() => shortlist_state = SHORTLIST_STATE.ADD} href="/"
           class="{shortlist_state === SHORTLIST_STATE.ADD ? `text-gray-900` : `text-gray-500 hover:text-gray-700`} rounded-l-lg group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10" aria-current="page">
            <span>Add</span>
            <span aria-hidden="true" class="{shortlist_state === SHORTLIST_STATE.ADD ? `bg-indigo-500` : `bg-transparent`} absolute inset-x-0 bottom-0 h-0.5"></span>
        </a>

        <a on:click|preventDefault={() => shortlist_state = SHORTLIST_STATE.REMOVE} href="/"
           class="{shortlist_state === SHORTLIST_STATE.REMOVE ? `text-gray-900` : `text-gray-500 hover:text-gray-700`} group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10">
            <span>Remove</span>
            <span aria-hidden="true" class="{shortlist_state === SHORTLIST_STATE.REMOVE ? `bg-indigo-500` : `bg-transparent`} absolute inset-x-0 bottom-0 h-0.5"></span>
        </a>

        <a on:click|preventDefault={() => shortlist_state = SHORTLIST_STATE.SEND} href="/"
           class="{shortlist_state === SHORTLIST_STATE.SEND ? `text-gray-900` : `text-gray-500 hover:text-gray-700`} rounded-r-lg group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10">
            <span>Send</span>
            <span aria-hidden="true" class="{shortlist_state === SHORTLIST_STATE.SEND ? `bg-indigo-500` : `bg-transparent`} absolute inset-x-0 bottom-0 h-0.5"></span>
        </a>
    </nav>
</div>
<div class="min-w-full h-[78vh] max-h-[78vh] overflow-auto">

    {#if shortlist_state === SHORTLIST_STATE.ADD}
    <div class="mt-4 px-4 sm:px-6 lg:px-8">

        <div class="flex space-x-4">
            <SearchBox bind:current_search_str></SearchBox>
            <button on:click={onFilterButtonToggle} class="inline-flex justify-center rounded-md border border-gray-300 bg-white px-3.5 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2">
                <svg class="h-5 w-5 text-gray-400" x-description="Heroicon name: mini/funnel" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 01.628.74v2.288a2.25 2.25 0 01-.659 1.59l-4.682 4.683a2.25 2.25 0 00-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 018 18.25v-5.757a2.25 2.25 0 00-.659-1.591L2.659 6.22A2.25 2.25 0 012 4.629V2.34a.75.75 0 01.628-.74z" clip-rule="evenodd"></path>
                </svg>
                <span class="sr-only">Filter</span>
            </button>
        </div>

        {#if filter_active}
            <TagFilter bind:filter></TagFilter>
        {/if}

        <BucketChooser bind:person_buckets bind:chosen_letter></BucketChooser>
    </div>

    <ol role="list" class="divide-y divide-gray-300">
        {#each person_buckets[chosen_letter] as person (person[I_PERSON.ID])}
        <li>
            <div class="flex items-center px-4 py-4 sm:px-6 {inArray(shortlist_people_ids, person[I_PERSON.ID]) ? 'bg-green-50' : ''}">
                <div class="min-w-0 flex-1 flex items-center justify-between">

                    <div
                        on:click={() => viewPersonClicked(person[I_PERSON.ID])}
                        class="truncate" >
                        <div class="flex text-sm">
                            <p class="font-medium text-gray-900">{fullNameFromRawPerson(person)}</p>
                            <p class="truncate ml-1 flex-shrink-0 font-normal text-gray-700">{$additional_people_info[person[I_PERSON.ID]][0].position}</p>
                        </div>
                        <div class="mt-2 flex">
                            <div class="flex items-center text-sm text-gray-500">
                                <p>{$additional_people_info[person[I_PERSON.ID]][0].company_name}</p>
                            </div>
                        </div>
                    </div>

                    {#if inArray(shortlist_people_ids, person[I_PERSON.ID])}
                        <div class="ml-5 p-5 flex-shrink-0 font-medium text-white">
                            <svg class="h-5 w-5 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                    {:else}
                        <div
                                on:click={() => addPersonClicked(person[I_PERSON.ID])}
                                class="ml-5 p-5 flex-shrink-0 font-medium text-white bg-green-500 rounded-md border border-transparent">
                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
                            </svg>

                        </div>
                    {/if}

                </div>
            </div>
        </li>
        {/each}
    </ol>
    {:else}
    <!--Remove/Send-->
    <ol role="list" class="divide-y divide-gray-300">
        {#each shortlist_people_list as shortlist_person (shortlist_person.person.id)}
        <li>
            <div class="flex items-center px-4 py-4 sm:px-6">
                <div class="min-w-0 flex-1 flex items-center justify-between">

                    {#if shortlist_state === SHORTLIST_STATE.REMOVE}
                    <div
                            on:click={() => removePersonClicked(shortlist_person.person.id)}
                            class="mr-5 p-5 flex-shrink-0 font-medium text-white bg-red-500 rounded-md border border-transparent">
                        <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                        </svg>

                    </div>
                    {/if}

                    <div
                            on:click={() => viewPersonClicked(shortlist_person.person.id)}
                            class="truncate grow" >
                        <div class="flex text-sm">
                            <p class="font-medium text-gray-900">{shortlist_person.person.first_name} {shortlist_person.person.last_name}</p>
                            <p class="truncate ml-1 flex-shrink-0 font-normal text-gray-700">{$additional_people_info[shortlist_person.person.id][0].position}</p>
                        </div>
                        <div class="mt-2 flex">
                            <div class="flex items-center text-sm text-gray-500">
                                <p>{$additional_people_info[shortlist_person.person.id][0].company_name}</p>
                            </div>
                        </div>
                    </div>

                    {#if shortlist_state === SHORTLIST_STATE.SEND}
                    <div
                            on:click={() => console.log('button clicked')}
                            class="ml-5 p-5 flex-shrink-0 font-medium text-white bg-indigo-500 rounded-md border border-transparent">
                        <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 9v.906a2.25 2.25 0 01-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 001.183 1.981l6.478 3.488m8.839 2.51l-4.66-2.51m0 0l-1.023-.55a2.25 2.25 0 00-2.134 0l-1.022.55m0 0l-4.661 2.51m16.5 1.615a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V8.844a2.25 2.25 0 011.183-1.98l7.5-4.04a2.25 2.25 0 012.134 0l7.5 4.04a2.25 2.25 0 011.183 1.98V19.5z" />
                        </svg>

                    </div>
                    {/if}

                </div>
            </div>
        </li>
        {/each}
    </ol>
    {/if}

</div>


<style></style>